
import PropTypes from 'prop-types';
import { TableRow, TableCell, Checkbox, Avatar, Button, ListItemText, Table, Tooltip, MenuItem, IconButton } from "@mui/material";
import CustomPopover, {usePopover} from '../../components/custom-popover/index.js';
import Iconify from "src/components/iconify/iconify.js";
import { ConfirmDialog } from '../../components/custom-dialog/index.js';
import { useBoolean } from '../../hooks/use-boolean.js';
import { parseISO, format } from 'date-fns';
import { fCurrency } from '../../util/format-number.js';
import Label from '../../components/label/index.js';

export default function InvoiceTableRow({
    row, selected, onSelected, onDeleteRow, onEditRow, onViewRow, onSelectRow
}){
    console.log(row)
    const { invoiceNumber, invoiceTo, createDate, dueDate, totalAmount, status, send} = row;
    const popover = usePopover();
    const confirm = useBoolean();


 return (
    <>
    <TableRow hover selected={selected}>
            <TableCell sx={{ display: 'flex', alignItems: 'center'}}>
                <ListItemText 
                    primary={invoiceTo?.companyName}
                    secondary={invoiceNumber}
                    primaryTypographyProps={{ typography: 'body2'}}
                    secondaryTypographyProps={{
                        component: 'span',
                        color: 'text.disabled'
                    }}
                />
            </TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{format(parseISO(createDate), "dd/MM/yyyy")}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{format(parseISO(dueDate), "dd/MM/yyyy")}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{fCurrency(totalAmount)}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>{status}</TableCell>
            <TableCell sx={{whiteSpace: 'nowrap'}}>
                <Label
                  variant="soft"
                  color={
                    (send === 1 && 'success') ||
                    (send === 0  && 'error') || 
                    'error'
                  }
                >
                  {send === 1 ? "Yes" : "No"}
                </Label>
                
               </TableCell>

            <TableCell align="right" sx={{px: 1, whiteSpace: 'nowrap'}}>
                    <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
            </TableCell>

    </TableRow>
    <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{width: 180}}
    >
        <MenuItem onClick={onViewRow}>
            <Iconify icon="ic:round-print" />
            Print
        </MenuItem>
        <MenuItem onClick={onEditRow}>
            <Iconify icon="solar:pen-bold" />
            Update
        </MenuItem>

        <MenuItem onClick={() => {
            confirm.onTrue();
            popover.onClose();
         }} sx={{ color: 'error.main'}}>
            <Iconify icon="solar:trash-bin-trash-bold" />
            Delete
        </MenuItem>
            


    </CustomPopover>

    <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content={`Are you sure want to delete ${invoiceNumber}?`}
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      />

</>
 )

}

InvoiceTableRow.propTypes = {
    onViewRow: PropTypes.func,
  };
  